module Meevo.Components.Controls.HideInput {

    export interface ITextChangeStrategy {
        getActualValue(selectionStart: number, selectionEnd: number): string;
    }

    export abstract class StrategyBase implements ITextChangeStrategy {
        protected hiddenValue: string;
        protected actualValue: string;
        protected data: string | null;

        constructor(actualValue: string, hiddenValue: string, data: string | null) {
            this.data = data;
            this.actualValue = actualValue;
            this.hiddenValue = hiddenValue;
        }

        abstract getActualValue(selectionStart: number, selectionEnd: number): string;
    }
}
